import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";

type SetProductAmortizationXParams = {
  formId: string;
  value: string;
};

function SetProductAmortizationXReducer(
  state: ProposalState,
  { payload: { formId, value } }: PayloadAction<SetProductAmortizationXParams>,
) {
  state.productByFormId[formId].commercialConditions.amortizationX = value;
}

export default SetProductAmortizationXReducer;
